import { gql } from '@apollo/client';

export const GET_FORM_ELEMENTS = gql`
  query FormElements {
    formElements {
      phoneNumberSearchOperatorCodes
    }
  }
`;
